import { Form, Input, Button, Row, Col } from "antd";

const AmbulanceFilter = ({ onFilter, filterType }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const filters = {
      searchText: values.ambulanceNumber || null
    };
    onFilter(filters);
  };

  const handleReset = () => {
    form.resetFields();
    onFilter({});
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical" style={{ margin: "1rem"}} autoComplete="off">
      <Row gutter={16} style={{ alignItems: "center"}}>
        <Col span={6}>
          <Form.Item name="ambulanceNumber" label="Ambulance Number">
            <Input placeholder="Enter ambulance number" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Button type="primary" htmlType="submit">Apply Filters</Button>
          <Button onClick={handleReset} style={{ marginLeft: 8 }}>Reset</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default AmbulanceFilter;
